import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Covers public live/trainer routes as well as workspace pages without a page hook.
export default function AnalyticsRouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView('page_view'); }, [pathname]);
  return null;
}
